import { Map as ImmutableMap, Record } from 'immutable';
const TemplateEditorPublishStatus = Record({
  error: undefined,
  hasUnpublishedChanges: undefined,
  isUpdating: false,
  lastUpdated: null,
  validationErrors: ImmutableMap()
});
export default TemplateEditorPublishStatus;